import { action } from 'satcheljs';
import type { AssetId, ProjectId } from 'owa-timestream-types';

export const onAssetResizeStart = action(
    'onAssetResizeStart',
    (projectId: ProjectId, assetId: AssetId) => ({
        projectId,
        assetId,
    })
);

export const onAssetResizeEnd = action('onAssetResizeEnd');

export const showResizeHandles = action('showResizeHandles', (assetId: AssetId) => ({
    assetId,
}));
